import { AxiosResponse } from "axios";
import { default as API, default as api } from "../api";
import { Job } from "../models/job";

import { OrderToCustomerPortal } from "../models/customer.portal";
import { JobStatus } from "../models/job.status";

const OrderService = {
  async getById(id: number, options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/orders/web/${id}`, { params: options });
  },
  async types(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/orders/types`, { params: options });
  },
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/orders/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<any[]>> {
    return await API.get(`/orders`, { params: options });
  },
  async update(orderId: number, data: any, options?: any): Promise<AxiosResponse<any>> {
    console.log("[OrderService.update] Updating order with timezone:", {
      orderId,
      original: { timezone: data.timezone, timezoneId: data.timezoneId },
    });

    return await API.put(`/orders/${orderId}`, data, { params: options });
  },
  async cancel(orderId: number, data: any, options?: any): Promise<AxiosResponse<any>> {
    return await API.put(`/orders/cancel/${orderId}`, data, { params: options });
  },
  async store(data: any, companyId?: number, options?: any): Promise<AxiosResponse<any>> {
    if (companyId) data.companyId = companyId;

    console.log("[OrderService.store] Creating order with timezone:", {
      original: { timezone: data.timezone, timezoneId: data.timezoneId },
    });

    return await API.post(`/orders`, data, { params: options });
  },
  async getStatus(options?: any): Promise<AxiosResponse<JobStatus[]>> {
    return await API.get(`/jobs/status`, { params: options });
  },
  async getSymbols(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/symbols`, { params: options });
  },
  async getResources(orderId: number): Promise<AxiosResponse<any>> {
    return await api.get(`/orders/resources/${orderId}`);
  },
  async getDiaryList(options?: any): Promise<AxiosResponse<Job[]>> {
    return await API.get(`/jobs/diary`, { params: options });
  },
  async sendCustomerPortalLink(data: { jobId: number }): Promise<AxiosResponse<boolean>> {
    return await API.post(`/orders/send/email/customer/portal`, data);
  },
  async getCustomerPortal(token?: string): Promise<AxiosResponse<OrderToCustomerPortal>> {
    return await API.post(`/orders/customer/portal`, { token });
  },
};

export default OrderService;
